export enum PlayerTypeConstants {
    Man,
    Woman,
    Kid,
    Oldman
}